import { useClerk } from "@clerk/nextjs"

interface SignOutButtonProps {
  className?: string
  /** Fired right before the session is torn down (e.g. to track abandonment). */
  onSignOut?: () => void
}

/**
 * Escape hatch for the signup / onboarding flows. Auth or org context can fail
 * to resolve there (e.g. a signed-in user with no organization, or a
 * half-provisioned org), leaving the user with no way out. This always tears
 * down the session and returns them to the public sign-in page.
 */
export function SignOutButton({ className, onSignOut }: SignOutButtonProps) {
  const { signOut } = useClerk()

  return (
    <button
      type="button"
      onClick={() => {
        onSignOut?.()
        void signOut({ redirectUrl: "/signin" })
      }}
      className={`text-sm text-coval-text-muted hover:text-coval-text transition-colors ${className ?? ""}`}
      data-testid="sign-out-button"
    >
      Sign out
    </button>
  )
}
